import React from 'react';
import { Heading } from '@miro-site/core';
import { jsx as _jsx } from "react/jsx-runtime";

var Title = function Title(props) {
  return /*#__PURE__*/_jsx(Heading, {
    as: "h1",
    $align: "center",
    $variant: ['h3', 'h1', 'h1', 'h1'],
    $mb: [20, 32, 32, 32],
    $mx: "auto",
    $styles: {
      maxWidth: [null, 750, 750, 750]
    },
    children: props.children
  });
};

export default Title;